// const SET_APP_SETTING = 'SET_APP_SETTING'

const APP_SETTING_KEY_FILE_UPLOAD_ALLOWED_COMET_EXTENSIONS = 'AppSettings:FileUpload:AllowedCometExtensions'
const APP_SETTING_KEY_FILE_UPLOAD_ALLOWED_LANTEK_EXTENSIONS = 'AppSettings:FileUpload:AllowedLantekExtensions'
const APP_SETTING_KEY_FILE_UPLOAD_MAX_SIZE = 'AppSettings:FileUpload:MaxSize'
const APP_SETTING_KEY_ACCOUNT_LOCKOUT_FAILED_ATTEMPTS = 'AppSettings:AccountLockout:FailedAttempts'
const APP_SETTING_KEY_ACCOUNT_LOCKOUT_THRESHOLD = 'AppSettings:AccountLockout:Threshold'
const APP_SETTING_KEY_ACCOUNT_LOCKOUT_DURATION = 'AppSettings:AccountLockout:Duration'
const APP_SETTING_KEY_FILE_UPLOAD_MAX_ATTACHMENT_SIZE = 'AppSettings:FileUpload:MaxAttachmentSize'
const APP_SETTING_KEY_FILE_UPLOAD_ALLOWED_ATTACHMENT_EXTENSIONS = 'AppSettings:FileUpload:AllowedAttachmentExtensions'

export const GET_APP_SETTING = 'GET_APP_SETTING'
export const GET_APP_SETTING_SUCCESS = 'GET_APP_SETTING_SUCCESS'
export const GET_APP_SETTING_FAIL = 'GET_APP_SETTING_FAIL'

export const defaultAppSettingState = {
  fileUploadSettings: {
    allowedCometExtensions: [],
    allowedLantekExtensions: [],
    maxFileSize: 0,
    maxAttachmentFileSize: 0,
    allowedAttachmentExtensions: []
  },
  accountLockoutSettings: {
    failedAttempts: 0,
    threshold: 0,
    duration: 0
  },
  error: null,
  errorMessage: null
}

export default (state = defaultAppSettingState, action) => {
  switch (action.type) {
    case GET_APP_SETTING_SUCCESS:

      if (action.payload.data.success) {

        const appSettings = action.payload.data.settings;

        const allowedCometExtensionSetting = appSettings.find(setting => setting.id === APP_SETTING_KEY_FILE_UPLOAD_ALLOWED_COMET_EXTENSIONS);
        const allowedLantekExtensionSetting = appSettings.find(setting => setting.id === APP_SETTING_KEY_FILE_UPLOAD_ALLOWED_LANTEK_EXTENSIONS);
        const maxSizeSetting = appSettings.find(setting => setting.id === APP_SETTING_KEY_FILE_UPLOAD_MAX_SIZE);
        const failedAttemptsSetting = appSettings.find(setting => setting.id === APP_SETTING_KEY_ACCOUNT_LOCKOUT_FAILED_ATTEMPTS);
        const thresholdSetting = appSettings.find(setting => setting.id === APP_SETTING_KEY_ACCOUNT_LOCKOUT_THRESHOLD);
        const durationSetting = appSettings.find(setting => setting.id === APP_SETTING_KEY_ACCOUNT_LOCKOUT_DURATION);
        const maxAttachmentFileSizeSetting = appSettings.find(setting => setting.id === APP_SETTING_KEY_FILE_UPLOAD_MAX_ATTACHMENT_SIZE);
        const allowedAttachmentExtensionSetting = appSettings.find(setting => setting.id === APP_SETTING_KEY_FILE_UPLOAD_ALLOWED_ATTACHMENT_EXTENSIONS);

        return {
          ...state,
          fileUploadSettings: {
            allowedCometExtensions: allowedCometExtensionSetting ? allowedCometExtensionSetting.value.split(',') : [],
            allowedLantekExtensions: allowedLantekExtensionSetting ? allowedLantekExtensionSetting.value.split(',') : [],
            maxFileSize: maxSizeSetting ? parseInt(maxSizeSetting.value) : 0,
            maxAttachmentFileSize: maxAttachmentFileSizeSetting ? parseInt(maxAttachmentFileSizeSetting.value) : 0,
            allowedAttachmentExtensions: allowedAttachmentExtensionSetting ? allowedAttachmentExtensionSetting.value.split(',') : []
          },
          accountLockoutSettings: {
            failedAttempts: failedAttemptsSetting ? parseInt(failedAttemptsSetting.value) : 0,
            threshold: thresholdSetting ? parseInt(thresholdSetting.value) : 0,
            duration: durationSetting ? parseInt(durationSetting.value) : 0
          },
          error: false,
          errorMessage: null
        };
      }
      return {
        ...state,
        error: true,
        errorMessage: action.payload.data.errors
      };
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/appSettingReducer.js